import React from "react"
import Questions_Table from "../questionnaire_custom_answers"
import data from "./msadata/clinical_msa.json"
import Title from "../../../../utilities/other/title"
import Possible from "./msadata/clincial_msa_possible.json"
import probable from "./msadata/msa_auto.json"
function ClinicalMSA(props){
    const handler = (event) =>{
        props.handler("clinical_msa",event)
    }
    return(
        <div>
            <Title>MSA criteria - Old Guidelines</Title>
            <Questions_Table YesNoLabel={"Yes/No "} autoFilldata={true} title= 'fab' score={false} 
             autoFill={props.handlePspMsaAuto} questions={probable} data={props.data} disabled={props.edit} 
             answers={probable} handler={handler} />
            <Questions_Table YesNoLabel={"Yes/No "} autoFilldata={true} title= 'fab' score={false}  
            autoFill={props.handlePspMsaAuto} questions={Possible} data={props.data} disabled={props.edit} 
            answers={Possible} handler={handler} />
            <Questions_Table  score={false}  questions={data} data={props.data} disabled={props.edit} answers={data} handler={handler} />
        </div>
    )
}

export default ClinicalMSA